import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment.prod';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class ValoresService {

  API_URI = environment.API_URL;
  constructor(private http: HttpClient) { }

  getValores(){
    return this.http.get(`${this.API_URI}/valores`)
  }

  getValor(id:string){
    return this.http.get(`${this.API_URI}/valores/${id}`);
  }

  actualizarValor(id: string | number, datos: any): Observable<any> {
    return this.http.put(`${this.API_URI}/valores/${id}`, datos);
  }
  
  crearValor(datos: any) {
    return this.http.post(`${this.API_URI}/valores`, datos);
  }

  eliminarValor(id: string): Observable<any> {
    return this.http.delete(`${this.API_URI}/valores/${id}`);
  }

}
